import type { FC, HTMLAttributes } from 'react';
import clsx from 'clsx';

import type { IStyledListItemProps } from './StyledListItem';
import StyledListItem from './StyledListItem';
import styles from './styles.module.scss';

interface Props extends HTMLAttributes<HTMLUListElement> {
    className?: string;
    listItems: IStyledListItemProps[];
}

const StyledList: FC<Props> = ({ className, listItems, ...htmlProps }) => {
    return (
        <ul className={clsx(styles.wrapper, className)} {...htmlProps}>
            {listItems.map((listItemProps, index) => {
                return <StyledListItem key={`${index}`} {...listItemProps} />;
            })}
        </ul>
    );
};

export default StyledList;
